/**
 * パッケージ
 */

// ポリフィル object-fit
//--------------------------------------------------
import objectFitImages from "object-fit-images";
objectFitImages();

// ポリフィル intersection-observer
//--------------------------------------------------
import "intersection-observer";

// ポリフィル stickyfill
//--------------------------------------------------
import Stickyfill from "stickyfilljs";
Stickyfill.add(document.querySelectorAll(".sticky"));

// ポリフィル smoothscroll-polyfill
//--------------------------------------------------
import smoothscroll from "smoothscroll-polyfill";
smoothscroll.polyfill();

// ライブラリ anime.js
//--------------------------------------------------
// import anime from "animejs";

/**
 * 自作モジュール - 共通
 */

// htmlエンティティとURLエンコード
//--------------------------------------------------
const htmlspecialchars = str => {
  return encodeURI(
    str
      .replace(/&/g, "&amp;")
      .replace(/</g, "&lt;")
      .replace(/>/g, "&gt;")
      .replace(/"/g, "&quot;")
      .replace(/'/g, "&#39;")
  );
};

// サイト内リンクかどうかの判定
//--------------------------------------------------
const isInternalLink = url => {
  if (typeof url != "string") {
    return false;
  } else if (url.indexOf(document.domain) !== -1) {
    return true;
  } else if (url.match(/^https?:\/\//)) {
    return false;
  } else {
    return true;
  }
};

// ページ内リンクかどうかの判定
//--------------------------------------------------
const isInpageLink = url => {
  let currentPageName = location.href
    .split("/")
    .pop()
    .replace(location.hash, "")
    .replace(location.search, "");
  if (currentPageName == "") currentPageName = "index";
  if (url.indexOf(currentPageName) === -1) {
    return false;
  } else {
    return true;
  }
};

// ページ遷移アニメーション
//--------------------------------------------------
const page_loader = () => {
  const grantClass2 = "is-transition-start";
  const anchors = document.querySelectorAll(
    'a:not([href^="#"]):not([href^="tel"]):not([href^="mailto"]):not([target]):not([data-rel])'
  );

  // ページ遷移前のアクション
  anchors.forEach(anchor => {
    if (
      isInternalLink(anchor.href) == true &&
      isInpageLink(anchor.href) === false
    ) {
      anchor.addEventListener(
        "click",
        event => {
          event.preventDefault();
          document.body.classList.add(grantClass2);
          setTimeout(() => {
            location = htmlspecialchars(anchor.href);
          }, 500);
        },
        {
          passive: false,
        }
      );
    }
  });
};
page_loader();

// スムーススクロール
//--------------------------------------------------
const smooth_scroll = () => {
  document.documentElement.style.scrollBehavior = "smooth";
  const userAgent = window.navigator.userAgent.toLowerCase();
  if (
    (userAgent.indexOf("safari") != -1 && userAgent.indexOf("chrome") == -1) ||
    userAgent.indexOf("trident") != -1
  ) {
    const nodeList = document.querySelectorAll('a[href*="#"]');
    const filename = location.href.match(".+/(.+?)([?#;].*)?$")[1];

    nodeList.forEach(node => {
      node.addEventListener("click", () => {
        // event.preventDefault();
        if (
          node.getAttribute("href") == "#" ||
          (node.getAttribute("href") == filename + "#" && location.href)
        ) {
          window.scrollTo({
            top: 0,
            behavior: "smooth",
          });
        } else {
          const target = document.querySelector(node.hash);
          if (target !== null) {
            const amount = target.getBoundingClientRect().top;
            window.scrollTo({
              top: amount,
              behavior: "smooth",
            });
          }
        }
      });
    });
  }
};
smooth_scroll();

// viewportに表示されるコンテンツに応じてbodyのidを変更する
//--------------------------------------------------
const area_ovserve = () => {
  // 初期設定
  const observedElements = document.querySelectorAll(".is-areaObserved");

  if (observedElements.length) {
    document.body.setAttribute("data-viewarea", observedElements[0].id);
  }
  //IntersectionObserverオプション
  const myOptions = {
    rootMargin: "-50% 0px -50% 0px",
    threshold: 0,
  };

  //IntersectionObserverコールバック
  const myCallback = entries => {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        document.body.setAttribute("data-viewarea", entry.target.id);
      }
    });
  };

  //インスタンス生成
  const myObserve = new IntersectionObserver(myCallback, myOptions);

  // 監視の開始
  observedElements.forEach(target => {
    myObserve.observe(target);
  });
};
area_ovserve();
